(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-media-w-text"] && !Shopify.designMode) return;
  try {
    
  function formatYotpoReviews(root) {
    if (!root) return;

    var summaryButtons = root.querySelectorAll('.product-media-w-text__content-reviews .yotpo-sr-bottom-line-summary');

    summaryButtons.forEach(function(button) {
      if (button.dataset.casperYotpoFormatted === 'true') return;

      var countSpan = button.querySelector('.yotpo-sr-bottom-line-text');
      if (!countSpan) return;

      var rawText = countSpan.textContent || '';
      var match = rawText.match(/\d+/);
      if (!match) return;

      var reviewCount = match[0];

      var scoreSpan = button.querySelector('.yotpo-sr-bottom-line-score');
      var dividerSpan = button.querySelector('.yotpo-sr-vertical-border');

      if (scoreSpan) scoreSpan.remove();
      if (dividerSpan) dividerSpan.remove();

      countSpan.textContent = reviewCount + ' Reviews';
      button.dataset.casperYotpoFormatted = 'true';
    });
  }

  // Initial run in case Yotpo is already rendered
  formatYotpoReviews(document);

  // Observe all instances of this section's reviews container
  var yotpoReviewContainers = document.querySelectorAll('.product-media-w-text__content-reviews');

  yotpoReviewContainers.forEach(function(container) {
    var yotpoObserver = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!(node instanceof HTMLElement)) return;

          if (
            node.matches('.product-media-w-text__content-reviews, .yotpo-widget-instance, .yotpo-reviews-star-ratings-widget, .yotpo-sr-bottom-line-summary') ||
            node.querySelector('.product-media-w-text__content-reviews, .yotpo-sr-bottom-line-summary')
          ) {
            formatYotpoReviews(node);
          }
        });
      });
    });

    yotpoObserver.observe(container, { subtree: true, childList: true });

    setTimeout(function() {
      yotpoObserver.disconnect();
    }, 15000);
  });

  } catch(e) { console.error(e); }
})();
})();
